import { WidgetElement } from './WidgetElement.js'

import * as WidgetData from './WidgetData.js'

import { bundleMagic } from './magics/bundle.js'
import { deviceMagic } from './magics/device.js'
import { queryMagic } from './magics/query.js'
import { sessionMagic } from './magics/session.js'
import { slotsMagic } from './magics/slots.js'
import { streamMagic } from './magics/stream.js'
import { tMagic } from './magics/t.js'
import { labelMagic } from './magics/label.js'
import { filterMagic } from './magics/filter.js'
import { globalFilterMagic } from './magics/filter.js'
import { widgetMagic } from './magics/widget.js'

import { canDirective } from './directives/can.js'
import { controllerDirective } from './directives/controller.js'
import { readyDirective } from './directives/ready.js'
import { stylingDirective } from './directives/styling.js'

import { Alpine as AlpineType } from 'alpinejs'
import { htmlWidgetDirective } from './directives/htmlWidgets.js'
// Treat everything as visible if IntersectionObserver is not defined
if (typeof IntersectionObserver === 'undefined') {
  // mock just calls it as it if now defined
  // @ts-ignore
  window.IntersectionObserver = class {
    constructor(fn: Function) {
      setTimeout(() => fn([{ isIntersecting: true }], null), 0)
    }
    observe() {}
    disconnect() {}
  }
}

// @ts-ignore
globalThis.WidgetData = WidgetData

export { WidgetElement }

export function plugin(Alpine: AlpineType) {
  // @ts-ignore
  globalThis.WidgetElement = WidgetElement

  Alpine.addRootSelector(() => '[x-data\\:widget]')

  Alpine.directive('can', canDirective)
  Alpine.directive('controller', controllerDirective)
  Alpine.directive('ready', readyDirective)
  Alpine.directive('styling', stylingDirective)
  Alpine.directive('html', htmlWidgetDirective)

  Alpine.magic('bundle', bundleMagic)
  Alpine.magic('query', queryMagic)
  Alpine.magic('session', sessionMagic)
  Alpine.magic('slots', slotsMagic)
  Alpine.magic('stream', streamMagic)
  Alpine.magic('t', tMagic)
  Alpine.magic('label', labelMagic)
  Alpine.magic('filter', filterMagic)
  Alpine.magic('globalFilter', globalFilterMagic)
  Alpine.magic('widget', widgetMagic)
  Alpine.magic('device', deviceMagic)

  // @ts-ignore
  Alpine.mergeStyles = function (...styles: string[]) {
    const result: Record<string, string> = {}
    for (let style of styles) {
      if (typeof style === 'string') {
        for (const line of style.split(';')) {
          const colonIndex = line.indexOf(':')
          if (colonIndex !== -1) {
            const propName = line.substring(0, colonIndex).trim()
            const value = line.substring(colonIndex + 1).trim()
            result[propName] = value
          }
        }
      } else {
        Object.assign(result, style)
      }
    }
    return result
  }

  // @ts-ignore
  Alpine.mergeClasses = function (...classes: string[]) {
    const result: Record<string, boolean> = {}
    for (let style of classes) {
      if (typeof style === 'string') {
        result[style] = true
      } else {
        Object.assign(result, style)
      }
    }
    return result
  }

  // window.WidgetData = WidgetData
}

export function $u(selector: string | HTMLElement) {
  let el: HTMLElement
  if (typeof selector === 'string') {
    const targetEl = document.querySelector(selector) as HTMLElement
    if (!targetEl) throw new Error('target element not found: ' + selector)

    el = targetEl
  } else if (selector instanceof HTMLElement) {
    el = selector
  } else {
    throw new Error('$u must be given a selector or element')
  }

  return dataFromClosestStack(el)

  function dataFromClosestStack(el: HTMLElement) {
    // @ts-ignore since it should be global
    const stack = Alpine.closestDataStack(el) as Record<string, any>[]
    const data: Record<string, any> = {
      get $parent(): Record<string, any> | null {
        return parentDataOf(el)
      }
    }
    for (const obj of stack.reverse()) {
      for (const [key, val] of Object.entries(obj)) {
        if (typeof val === 'function') {
          data[key] = val.bind(obj)
        } else {
          Object.defineProperty(data, key, {
            enumerable: true,
            configurable: true,
            get() {
              return obj[key]
            },
            set(newValue) {
              obj[key] = newValue
            }
          })
        }
      }
    }

    return data
  }

  function parentDataOf(el: HTMLElement): Record<string, any> | null {
    let parentEl: HTMLElement | null = el
    do {
      parentEl = parentEl.parentElement
      // @ts-ignore
    } while (parentEl && !parentEl._x_dataStack)

    if (parentEl) {
      return dataFromClosestStack(parentEl)
    }
    return null
  }
}

import { runScript } from './lib/run-script.js'
import { renderCode } from './lib/render-code.js'
import { installWidget } from './lib/install-widget.js'
import { injectHtml } from './lib/inject-html.js'

export { injectHtml, installWidget, renderCode, runScript }

// @ts-ignore
globalThis.Upland = {
  runScript,
  renderCode,
  installWidget,
  injectHtml
}
